import ScopeSearchModel from "./ScopeSearchModel";
import { useParams } from "react-router-dom";
import { useMemo } from "react";

export default function ScopeSearchGrid () {

    const { revisionId, equipmentid } = useParams();
    const extraParams = useMemo(() => ({ EquipmentId: equipmentid }), [equipmentid]);
    const baseFilters = useMemo(() => ([
            {
            field: "RevisionIds",
            operator: "notContains",
            value: revisionId,
            type: "csv"
        }]), [revisionId]);

    return (
        <ScopeSearchModel.Grid  
        baseFilters={baseFilters}
        onCellDoubleClickOverride={() => {}}
        extraParams={extraParams} />
    );
}